import React from "react";
import amirCollectionHeroImage from "./../assets/eftakari-collection-hero-image.jpg";
import focusPieceImageOne from "./../assets/focus-piece-one.jpg";
import focusPieceImageTwo from "./../assets/focus-piece-two.jpg";
import focusPieceImageThree from "./../assets/focus-piece-three.jpg";
import focusPieceImageFour from "./../assets/focus-piece-four.jpg";
import focusPieceImageFive from "./../assets/focus-piece-five.jpg";
import focusPieceImageSix from "./../assets/focus-piece-six.jpg";
import curatedMobileGalleryFour from "./../assets/curated-mobile-gallery-four.jpg";
import curatedMobileGalleryTwo from "./../assets/curated-mobile-gallery-two.jpg";
import NewNavbar from "../components/NewNavbar";
import Footer from "../components/Footer";
import { formatProductPrice } from "../utils.js";
import SEO from "../components/SEO.js";

const COLLECTION_DISCOUNT_PERCENT = 25;

const collectionPieces = [
  {
    id: 8,
    displayId: "01",
    name: "Persian Wrap Tee",
    image: "https://s3.us-east-2.amazonaws.com/eveness-2.0/uploads/1788944792523_64ae9e9740c0184a36f84f87f4c44657fa1730851.jpg",
    price: formatProductPrice("90.00"),
    cardPrice: formatProductPrice(60),
  },
  {
    id: 7,
    displayId: "02",
    name: "Persian Scarf Tee",
    image: "https://s3.us-east-2.amazonaws.com/eveness-2.0/uploads/1788944738617_aec43c4fc69fabc01b52f7450fd388aaf6bae1531.jpg",
    price: formatProductPrice("90.00"),
    cardPrice: formatProductPrice(20),
  },
  {
    id: 6,
    displayId: "03",
    name: "Persian Rug Tee",
    image: "https://s3.us-east-2.amazonaws.com/eveness-2.0/uploads/1788944672915_persian-rug-tee2.jpg",
    price: formatProductPrice("90.00"),
    cardPrice: formatProductPrice(120),
  },
];

const galleryImages = [
  focusPieceImageOne,
  focusPieceImageFour,
  focusPieceImageTwo,
  focusPieceImageFive,
  focusPieceImageThree,
  focusPieceImageSix,
  curatedMobileGalleryTwo,
  curatedMobileGalleryFour,
];

const SectionLabel = ({ number, children }) => {
  return (
    <div className="flex items-center gap-2 font-spaceMono text-[10px] uppercase tracking-[0.08em] text-[#6B7280] md:gap-3 md:text-[14px]">
      <span className="text-slate-900">{number}</span>
      <span className="h-px w-4 bg-amber-400 lg:w-5" />
      <span>{children}</span>
    </div>
  );
};

const CollectionProductCard = ({ piece }) => {
  return (
    <article className="group overflow-hidden rounded-[5px] bg-white">
      {/* PRODUCT IMAGE */}
      <button
        type="button"
        className="relative block w-full overflow-hidden bg-[#ebe7e1] text-left"
        aria-label={`View ${piece.name}`}
      >
        <img
          src={piece.image}
          alt={piece.name}
          className="aspect-[0.82] w-full object-cover object-center
            transition-all duration-300 ease-out md:group-hover:scale-[1.03]
            md:group-hover:brightness-[0.72] sm:aspect-[0.78] lg:aspect-[0.76]"
        />
        {/* Desktop black hover gradient */}
        <div
          aria-hidden="true"
          className="
            pointer-events-none absolute inset-0 hidden
            bg-[linear-gradient(180deg,rgba(0,0,0,0.18)_0%,rgba(0,0,0,0.05)_35%,rgba(0,0,0,0.46)_100%)]
            opacity-0 transition-opacity duration-300
            md:block md:group-hover:opacity-100
          "
        />
      </button>
      {/* PRODUCT DETAILS */}
      <div className="px-2 pb-2 pt-2 sm:px-2.5">
        <div className="flex items-center justify-between gap-3">
          <button
            type="button"
            className="min-w-0 truncate text-left font-helvena text-[12px] uppercase leading-none text-black hover:underline md:text-[14px]"
          >
            {piece.displayId} — {piece.name}
          </button>
          <span className="shrink-0 font-helvena text-[12px] leading-none text-black md:text-[14px]">
            {piece.cardPrice}
          </span>
        </div>
      </div>
    </article>
  );
};

const FinalSaleSection = ({ products }) => {
  const [activeIndex, setActiveIndex] = React.useState(0);
  const desktopSliderRef = React.useRef(null);

  const activeProduct = products[activeIndex];

  const handleDesktopScroll = () => {
    const slider = desktopSliderRef.current;
    if (!slider) return;
    const slideWidth = slider.clientWidth;
    const newIndex = Math.round(slider.scrollLeft / slideWidth);
    if (
      newIndex >= 0 &&
      newIndex < products.length &&
      newIndex !== activeIndex
    ) {
      setActiveIndex(newIndex);
    }
  };

  if (!activeProduct) return null;

  return (
    <section className="relative overflow-hidden pt-2 px-58 sm:pb-10 pb-16 md:px-[72px] md:pb-[72px]">
      {/* BACKGROUND */}
      <div
        aria-hidden="true"
        className="absolute inset-x-0 bottom-0 top-[36px] sm:top-[60px]"
      />
      {/* FINAL SALE CARD */}
      <div
        className="relative z-10 mx-auto grid max-w-[1260px]
            grid-cols-1 items-center gap-6
            overflow-hidden rounded-[10px] bg-white
            px-6 py-6
            lg:grid-cols-[0.9fr_1.1fr]
            lg:gap-[72px]
            shadow-[0px_4px_238.3px_0px_#00000033"
      >
        {/* PRODUCT */}
        <div className="min-w-0 w-full">
          <div
            ref={desktopSliderRef}
            onScroll={handleDesktopScroll}
            className="
                flex h-[360px] w-full
                snap-x snap-mandatory
                overflow-x-auto overflow-y-hidden
                scroll-smooth overscroll-x-contain
                rounded-[4px] bg-[#F3F0EA]
                [scrollbar-width:none]
                [&::-webkit-scrollbar]:hidden
                sm:h-[440px]
                md:h-[500px]
                lg:h-[557px]
              "
          >
            {products.map((product) => (
              <button
                key={product.id}
                type="button"
                className="h-full w-full shrink-0 snap-center overflow-hidden text-left"
              >
                <img
                  src={product.image}
                  alt={product.name}
                  draggable={false}
                  className="h-full w-full select-none object-cover object-center"
                />
              </button>
            ))}
          </div>
          {/* PRODUCT NAME + PRICE */}
          <div className="flex items-center justify-between gap-3 px-1 py-2 sm:px-2 bg-[#FAF7F2]">
            <p className="min-w-0 truncate font-helvena text-[11px] uppercase text-black sm:text-[12px] md:text-[14px]">
              {activeProduct.displayId} — {activeProduct.name}
            </p>

            <span className="shrink-0 font-helvena text-[11px] text-black sm:text-[12px] md:text-[14px]">
              {activeProduct.price}
            </span>
          </div>
          {/* CAROUSEL INDICATORS */}
          <div className="mt-3 flex items-center justify-center gap-[5px] sm:mt-5">
            {products.map((product, index) => {
              const isActive = index === activeIndex;
              return (
                <button
                  key={product.id}
                  type="button"
                  aria-label={`View ${product.name}`}
                  className={`h-[5px] rounded-full bg-black transition-all duration-300 sm:h-[6px] ${
                    isActive ? "w-[42px] sm:w-[68px]" : "w-[10px] sm:w-[13px]"
                  }`}
                />
              );
            })}
          </div>
        </div>
        {/* CONTENT */}
        <div className="min-w-0 pb-2 pt-1 lg:mb-5 lg:pb-0 lg:pr-6 lg:pt-0">
          <p className="font-spaceMono text-[10px] font-bold uppercase leading-[1.5] tracking-[0.06em] text-[#A64346] sm:text-[12px] md:text-[14px]">
            One time orders before the collection is gone forever.
          </p>
          <h2 className="mt-3 font-inter text-[28px] font-bold leading-[1.05] tracking-[-0.04em] text-[#111827] sm:text-[34px] md:text-[40px] lg:mt-4 lg:text-[48px]">
            9/31/26 Final Sale Date
          </h2>
          <p className="mt-4 max-w-[610px] font-inter text-[12px] font-normal leading-[1.65] text-[#6B7280] sm:text-[14px] md:text-[16px] lg:mt-5 lg:text-[18px]">
            Alongside Amir Eftekhari, Amir Razipour combines his time spent
            studying fashion in London at Central St. Martins with inspirations
            from Eftekhari’s contemporary Persian art form. Each piece serves as
            an allegory to a modern Persia.{" "}
          </p>

          {/* PAYMENT */}
          <div className="mt-6 sm:mt-8 lg:mt-[72px]">
            <p className="mt-3 font-inter text-[11px] leading-[1.5] text-[#0F0F10] sm:text-[12px] md:text-[14px]">
              Express pay,{" "}
              <span className="font-semibold">
                Bundle the entire Collection for {COLLECTION_DISCOUNT_PERCENT}%
                Off.
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

const AmirCollectionPage = () => {
  return (
    <div className="relative bg-[#f7f5f1]">
      <SEO
        title="Amir Eftekhari Collection | Limited-Edition Fashion | Eveness"
        description="Discover the Amir Eftekhari Collection by Eveness, featuring limited-edition contemporary fashion made in London and inspired by Persian heritage."
        path="/eftakhari-collection"
      />
      <NewNavbar mobileOverlayOnContent showAmirCollection />
      <main className="min-h-screen text-[#111827]">
        <section className="mx-auto grid max-w-[1536px] grid-cols-1 md:mt-5 lg:grid-cols-2">
          {/* LEFT CONTENT */}
          <div className="order-2 flex min-h-0 flex-col bg-white px-2.5 pb-5 pt-3 lg:order-1 lg:min-h-[640px] lg:px-[80px] lg:py-[92px]">
            <SectionLabel number="Eveness">Amir Collection</SectionLabel>

            <h1 className="mt-3 max-w-[240px] md:max-w-[450px] text-[20px] font-normal leading-[120%] tracking-[-0.035em] text-[#111827] sm:text-[30px] lg:mt-6 md:text-[38px]">
              Contemporary Fashion, Made in London, Embracing Persia.
            </h1>

            {/* DESKTOP ONLY CONTENT */}
            <div className="mt-auto pt-5 md:pt-20 block">
              <p className="max-w-[570px] font-montserrat text-[10px] md:text-[15px] leading-[1.75] text-[#6B7280]">
                Amir Razipour and Amir Eftekhari reinterpret Persian heritage
                across three limited-edition pieces, bringing traditional motifs
                into contemporary form.
              </p>

              <div className="mt-7 grid max-w-[620px] grid-cols-2 border-y border-[#E5E7EB]">
                <div className="py-6 pr-4">
                  <p className="font-spaceMono text-[12px] font-bold uppercase text-[#6B7280]">
                    Launch Date
                  </p>

                  <p className="mt-2 font-montserrat text-[12px] md:text-[14px] font-medium text-[#111827]">
                    9/15/26
                  </p>
                </div>

                <div className="py-6 pl-4">
                  <p className="font-spaceMono text-[12px] font-bold uppercase text-[#6B7280]">
                    Collection Closes
                  </p>

                  <p className="mt-2 font-montserrat text-[12px] md:text-[14px] font-medium text-[#111827]">
                    9/31/26
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* HERO IMAGE */}
          <div className="order-1 w-full overflow-hidden lg:order-2 lg:max-h-[700px]">
            <img
              src={amirCollectionHeroImage}
              alt="Amir Collection"
              className="aspect-[0.84] md:aspect-[0.95] w-full object-cover object-top-left md:object-[40%_60%] md:max-h-[700px]"
            />
          </div>
        </section>

        {/* CURATED PIECES */}
        <section className="mx-auto max-w-[1536px] bg-[#FAF7F2] px-3 pb-4 pt-0 sm:px-5 md:px-8 md:pb-8 md:pt-8 lg:px-[34px]">
          {/* QUOTE */}
          <div className="mx-auto max-w-[720px] text-center font-inter text-[12px] text-[#0F0F10] md:text-[16px]">
            "I've always carried Iran with me wherever I go. This was a chance
            to bring that heritage into something new, and let it live in a
            different language."
          </div>
          <div className="justify-center flex text-[12px] text-[#0F0F10] md:text-[16px]">
            <ul className="list-disc">
              <li className="font-normal">Amir Eftekhari</li>
            </ul>
          </div>
          {/* PRODUCTS */}
          <div className="mt-3 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:mt-8 lg:grid-cols-3 lg:gap-5">
          {collectionPieces.map((piece) => (
              <CollectionProductCard
                key={piece.id}
                piece={piece}
              />
            ))}
          </div>
            <p className="mt-4 text-center font-spaceMono text-[10px] font-semibold uppercase tracking-[0.08em] text-[#A64346] md:text-[12px]">
              Made to Order in London. Final Sale. No returns.
            </p>
          {/* BUNDLE PURCHASE */}
          {collectionPieces.length > 0 && (
            <div className="mt-7 flex flex-col items-center justify-center text-center mx-auto md:mt-8">
              <p className="font-inter text-[11px] font-normal leading-relaxed text-[#0F0F10] md:text-[14px]">
                Express pay,{" "}
                <span className="font-semibold">
                  Bundle the entire Collection for {COLLECTION_DISCOUNT_PERCENT}
                  % Off.
                </span>
              </p>
              {/* ADD ALL TO CART */}
            </div>
          )}
        </section>

        {/* FOCUS PIECE / GALLERY */}
        <section className="bg-white pt-8 md:pt-10">
          {/* SECTION TITLE */}
          <div className="px-3 sm:px-5 md:px-8 lg:px-[80px]">
            <SectionLabel number="04">Focus Piece</SectionLabel>
          </div>
          {/* MOBILE GALLERY */}
          <div className="mt-5 px-1.5 pb-4 md:hidden">
            {/* FIRST ROW */}
            <div className="grid grid-cols-[1.55fr_0.9fr] gap-1.5">
              <img
                src={galleryImages[5]}
                alt="Amir Collection"
                className="h-full max-h-[300px] min-w-0 w-full rounded-[3px] object-cover"
              />

              <img
                src={galleryImages[6]}
                alt="Amir Collection"
                className="h-full min-h-[300px] min-w-0 w-full rounded-[3px] object-cover"
              />
            </div>

            {/* FULL WIDTH IMAGE */}
            <div className="mt-1.5 aspect-[1.05] w-full overflow-hidden rounded-[3px]">
              <img
                src={galleryImages[1]}
                alt="Amir Collection"
                className="h-full w-full scale-[1.15] object-cover object-[30%_70%]"
              />
            </div>

            {/* BOTTOM TWO IMAGES */}
            <div className="mt-1.5 grid grid-cols-2 gap-1.5">
              <div className="aspect-[0.73] w-full overflow-hidden rounded-[3px]">
                <img
                  src={galleryImages[7]}
                  alt=""
                  className="h-full w-full scale-[1.5] object-cover object-center"
                />
              </div>

              <div className="aspect-[0.73] w-full overflow-hidden rounded-[3px]">
                <img
                  src={amirCollectionHeroImage}
                  alt=""
                  className="h-full w-full scale-[1.5] object-cover object-[0%_100%]"
                />
              </div>
            </div>
          </div>
          {/* DESKTOP GALLERY */}
          <div className="mx-auto mt-8 hidden max-w-[1536px] grid-cols-3 gap-4 px-8 md:grid lg:mt-16 lg:gap-5 lg:px-[80px]">
            {/* COLUMN 1 */}
            <div className="space-y-5">
              <img
                src={galleryImages[0]}
                alt="Amir Collection"
                className="aspect-[0.81] w-full rounded-[5px] object-cover"
              />

              <img
                src={galleryImages[1]}
                alt=""
                className="aspect-[1.07] w-full rounded-[5px] object-cover"
              />
            </div>
            {/* COLUMN 2 */}
            <div className="space-y-5">
              <img
                src={galleryImages[2]}
                alt=""
                className="aspect-[1.07] w-full rounded-[5px] object-cover"
              />

              <img
                src={galleryImages[3]}
                alt=""
                className="aspect-[0.81] w-full rounded-[5px] object-cover"
              />
            </div>
            {/* COLUMN 3 */}
            <div className="space-y-5">
              <img
                src={galleryImages[4]}
                alt=""
                className="aspect-[0.81] w-full rounded-[5px] object-cover"
              />

              <img
                src={galleryImages[5]}
                alt=""
                className="aspect-[1.07] w-full rounded-[5px] object-cover"
              />
            </div>
          </div>
          {/* STORY */}
          <div className="flex w-full flex-col px-3 pb-10 pt-8 sm:px-5 md:px-8 md:pt-10 lg:px-[80px] bg-[#FAF7F2]">
            <SectionLabel number="01">The Story</SectionLabel>
            <h1 className="mt-3 w-full text-[20px] font-normal leading-[120%] tracking-[-0.035em] text-[#111827] sm:text-[30px] md:text-[38px] lg:mt-8">
              Inspired by the culture we love.
            </h1>
          </div>
        </section>

        {/* FINAL SALE / FEATURE PRODUCT */}
        <FinalSaleSection products={collectionPieces} />
      </main>
      <Footer />
    </div>
  );
};

export default AmirCollectionPage;
